import { useCallback } from 'react';
import { useClient } from 'urql';

import {
  BagPaymentInfoDocument,
  type BagPaymentInfoQuery,
} from '../../GraphQL/BagPaymentInfo.generated';

// ────────────────────────────────────────────────────────────────────────────

/**
 * A hook for fetching payment info for the bag.
 */
export const useBagPaymentInfo = () => {
  const client = useClient();

  // ─── Queries ──────────────────────────────────────────────────────────────

  const fetchBagPaymentInfo = useCallback(async () => {
    const response = await client
      .query<BagPaymentInfoQuery>(
        BagPaymentInfoDocument,
        {},
        { requestPolicy: 'network-only' },
      )
      .toPromise();

    const info = response.data?.customerPaymentInfo;

    const stripeCustomerId = info?.id ?? '';
    const stripeCustomerKey = info?.paymentEphemeralKey ?? '';
    const stripeSession = info?.paymentSessionId ?? '';

    return {
      stripeCustomerId,
      stripeCustomerKey,
      stripeSession,
    };
  }, [client]);

  return { fetchBagPaymentInfo };
};
